<template>
  <div class="container">
    <iframe :src="url" v-if="url && url.indexOf('.apk') < 0"></iframe>
    <div class="mask"></div>
    <div class="bubble" v-if="showTips">
      <div class="talk">请点击右上角<br>选择"浏览器中打开"</div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      showTips: false,
      url: ''
    }
  },
  created() {
    // 如果传了url，则调用该url
    var url = this.$route.query.url;
    if (url == null || url == '') {
      // 如果没传url，则走酷安
      url = 'https://coolapk.com/apk/' + this.$route.params.packageName;
    }
    // 判断是否在微信中打开，如果是，则提示打开浏览器下载
    var ua = navigator.userAgent.toLowerCase();
    var isWeixin = ua.indexOf('micromessenger') >= 0;
    var isQQ = ua.indexOf('qq') >= 0;
    if (!isWeixin && !isQQ) {
      window.location.href = url;
    } else {
      document.title = '下载';
      this.url = url;
      this.showTips = true;
    }
  }
}
</script>

<style lang="less" scoped>
.container {
  width: 100vw;
  height: 100vh;

  iframe {
    padding: 0;
    margin: 0;
    border: none;
    width: 100vw;
    min-height: 100vh;
  }
  .mask {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 1000;
  }
  .bubble {
    position: fixed;
    top: 22px;
    right: 6px;
    border-radius: 5px;
    color: #ddd;
    background-color: rgb(192, 72, 81);
    font-size: 14px;

    .talk {
      padding: 12px;
      color: #FFFFFF;
      text-align: center;
    }
  }
  .bubble:after{content:'';position:absolute;bottom:100%;right:0px;width:16px;height:16px;border-width:0;border-style:solid;border-color:transparent;border-left-width:10px;border-left-color:currentColor;border-radius:32px 0 0 0;color:#C04851;}
}
</style>
